import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VehicleInspectionsCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showVehicleInspections = !!$scope.inspections.length;
  $scope.tableCacheKey          = 'vehicleInspections';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'inspection_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.INSPECTION_NUMBER')
        },
      },
      {
        field : 'inspection_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'inspection_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'inspectionStatus'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInspection(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('INSPECTIONS_SPACE.NO_INSPECTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vehicles/inspection_count', $scope.vehicle.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'inspection_date'
    })
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInspection(event.row);
  };

  $scope.viewInspection = function(inspection) {
    $state.go('app.inspection', {
      customer_id: inspection.customer_id,
      vehicle_id : inspection.vehicle_id,
      id         : inspection.id
    });
  };

  $scope.getInspections = ( params ) => {
    return workshopAPI.get('/vehicles/inspection_list', [
      $scope.vehicle.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(inspections => {
      $scope.inspections = inspections;

      return inspections;
    });
  };
};